import moment from 'moment';

export const START_DATE_ID = 'startDate';
export const END_DATE_ID = 'endDate';

export const DEFAULT_MIN_DATE = moment('2000-01-01', 'YYYY-MM-DD');
const maxDateYear = 5;
export const DEFAULT_MAX_DATE = moment()
    .add(maxDateYear, 'year')
    .endOf('year');

export interface DateRangePickerProps {
    className?: string;
    timeFrameInDays?: string;
    minDate?: moment.Moment;
    maxDate?: moment.Moment;
    field?: string;
    selectedDateField?: string;
    allowSingleDay?: boolean;
    disabled?: boolean;
    selectTimeRange: (startDate: string | moment.Moment, endDate: string | moment.Moment, field?: string) => void;
}